<template>
  <div class="flex min-h-screen items-center justify-center bg-gray-100">
    <div class="text-center">
      <h1 class="mb-4 text-4xl font-bold text-[#7c2622]">
        404
      </h1>

      <p class="mb-4 text-xl text-gray-600">
        Oops! Page not found
      </p>

      <router-link
        to="/"
        class="text-[#7c2622] underline hover:text-[#671f1c]"
      >
        Return to Home
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  mounted() {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      this.$route.path
    )
  },
}
</script>